import React from 'react';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import ErrorIcon from '../../../../assets/svg/ErrorIcon';
import ValidationInfoSchema from './ValidationInfoSchema';
import { IdType } from 'fulogics-ui-core/dist/api/models/IdType';
import OrderErrorInfo, {
    OrderErrorInfoDisplayOptions,
    OrderValidationResult,
} from '../../../../components/order-error-info/OrderErrorInfo';

const ValidationInfo = (props: ValidationInfoProps) => {
    const validationResult = {
        ...props.validationResult,
        brokenRules: props?.validationResult?.brokenRules?.filter(
            ({ relatedEntityId }) => relatedEntityId === props.data?.id
        ),
    };

    const data = {
        validationResult,
    };

    const showIcon = !!validationResult?.brokenRules?.length;

    return showIcon ? <OrderErrorInfo {...props.orderErrorInfoDisplayOptions} data={data} /> : null;
};

export type ValidationInfoProps = {
    data?: ValidationInfoData;
} & ValidationInfoDisplayOptions;

export default withInspector<ValidationInfoProps>(ValidationInfo, ValidationInfoSchema);

export interface ValidationInfoDisplayOptions {
    id?: string;
    className?: string;
    //
    validationResult?: OrderValidationResult;
    orderErrorInfoDisplayOptions?: OrderErrorInfoDisplayOptions;
}

export type ValidationInfoData = {
    id?: IdType;
};

export const ValidationInfoDataKeys = ['id'];
